module.exports = __webpack_public_path__ + "img/Fife.b8ba6b36.png";